import { Component, h, State, Prop } from '@stencil/core';
import { getConversationEligibleMembers, addConversationMember } from '../../api/group-members.js';
import { getGroupcastEligibleMembers, addGroupcastMember} from '../../api/groupcast.js'
import { showToast } from '../../stories/Components/Toaster/toast-helper';
import { drawerDialogService } from '../../stories/Components/Dialog-Drawer/dialog-drawer.js';
import '../../stories/Components/MembersList/MembersList.js';
@Component({
  tag: 'member-add',
  styleUrl: '',
  shadow: true,
})
export class MemberAdd {
  @Prop() dialogData:any = {};
  @State() eligibleMembers: any = [];
  @State() membersListSkip: any = 0;
  @State() hasMore: any = false;
  @State() isLoading: boolean = false;
  @State() paginationLoading: boolean = false;

  async componentDidLoad() {
    await this.handleGetEligibleMembers(null,0); 
  }
  async handleGetEligibleMembers(searchTag='',skip=0) {
    if (skip === 0) {
      this.isLoading = true;
      this.eligibleMembers = [];
    }

    if (skip >= 20) {
      this.paginationLoading = true;
    }    
    this.hasMore = true;
    try {
      this.membersListSkip = skip;
      let payload ={
        conversationId: this.dialogData.selectedConversationId,
        limit: 20,
        skip: skip,
      }
      let groupcastPayload = {
        groupcastId: this.dialogData.selectedConversationId,  
        limit: 20,
        skip: skip,
      }
      if(searchTag){
        payload['searchTag'] = searchTag;
      }
      let eligibleMembers;
      if(this.dialogData.isGroupcast) {
         eligibleMembers = await getGroupcastEligibleMembers({...groupcastPayload})
      } else {
        eligibleMembers =  await getConversationEligibleMembers({...payload});
      }
      if (eligibleMembers) {
        const members = this.dialogData?.isGroupcast ? eligibleMembers?.groupcastEligibleMembers : 
        eligibleMembers?.conversationEligibleMembers;
        if (this.membersListSkip === 0) {
            this.eligibleMembers = [...members];
        } else {
            this.eligibleMembers = [...this.eligibleMembers, ...members];
        }
      }

      if (eligibleMembers?.conversationEligibleMembers?.length < payload.limit) {
        this.hasMore = false;
      }
    } catch (error) {
      if (error?.status === 404 || error?.statusCode === 404) {
        this.hasMore = false;
      }
      if ((error?.status === 404 || error?.statusCode === 404) && searchTag != null) {
        this.eligibleMembers = [];
      }
    } finally {
      this.isLoading = false;
      this.paginationLoading = false;
    }
  }
  async handleAddMember(selectedUserIds:any){
    try {
      if(this.dialogData?.isGroupcast) {
        await addGroupcastMember(this.dialogData.selectedConversationId, selectedUserIds)
      } else {
      await addConversationMember(this.dialogData.selectedConversationId, selectedUserIds);
      }
      showToast({
        message: 'Members added successfully',
        type: 'success',
        duration: 3000,
        position: 'bottom-left',
      });
    } catch (error) {
      console.error('Error adding members to conversation:', error);
      showToast({
        message: 'Failed to add members',
        type: 'error',
        duration: 3000,
        position: 'bottom-left',
      });
    } finally{
      drawerDialogService.closeDialog('member-add');
    }
  }
  render() {
    return (
      <members-list
        handleGetEligibleMembers={this.handleGetEligibleMembers}
        isLoading={this.isLoading}
        hasMore={this.hasMore}
        membersListSkip={this.membersListSkip}
        paginationLoading={this.paginationLoading}
        handleAddMember={this.handleAddMember}
        dialogData={this.dialogData}
        eligibleMembers={this.eligibleMembers}
      ></members-list>
    )}
}